import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { therapyPlanningAction } from '../../actions/constant';
import therapyPlanningService from '../../../services/apiServices/therapyPlanning/therapyPlanning';

const {
  GET_AUTHORIZATION_DETAILS_REQUEST,
  GET_AUTHORIZATION_DETAILS_SUCCESS,
  GET_AUTHORIZATION_DETAILS_FAILURE,
  GET_AUTHORIZATION_DETAILS_LOADER,
  GET_AUTHORIZATION_DETAILS_RESET,
} = therapyPlanningAction;

function* getAuthorizationDetails(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_AUTHORIZATION_DETAILS_LOADER });
    const response = yield call(therapyPlanningService.getAuthDetails, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: GET_AUTHORIZATION_DETAILS_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_AUTHORIZATION_DETAILS_FAILURE, payload: error });
  }
}

function* getAuthorizationDetailsSaga() {
  yield takeEvery(GET_AUTHORIZATION_DETAILS_REQUEST, getAuthorizationDetails);
}

export default getAuthorizationDetailsSaga;
